import React, { SVGProps } from 'react';

export default function IconDirection(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.7098 11.29L12.7098 2.29C12.3198 1.9 11.6898 1.9 11.2998 2.29L2.29982 11.29C1.90982 11.68 1.90982 12.31 2.29982 12.7L11.2998 21.7C11.6898 22.09 12.3198 22.09 12.7098 21.7L21.7098 12.7C22.0998 12.32 22.0998 11.69 21.7098 11.29ZM13.9998 14.5V12H9.99982V15H7.99982V11C7.99982 10.45 8.44982 10 8.99982 10H13.9998V7.5L17.4998 11L13.9998 14.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
